import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Breadcrumbs component
 * @param {Array<{ label: string, to?: string }>} items - Array of breadcrumb items. If 'to' is provided, item is a link.
 * @param {string} className - Optional extra classes
 */
const Breadcrumbs = ({ items = [], className = '' }) => {
  const navigate = useNavigate();
  if (!items || items.length === 0) return null;
  return (
    <nav className={`flex items-center text-sm text-gray-500 mb-4 ${className}`} aria-label="Breadcrumb">
      {items.map((item, idx) => (
        <span key={idx} className="flex items-center">
          {item.to ? (
            <button
              type="button"
              onClick={() => navigate(item.to)}
              className="text-primary-600 hover:underline focus:outline-none focus:underline pr-1"
            >
              {item.label}
            </button>
          ) : (
            <span className="text-gray-700 font-medium pr-1">{item.label}</span>
          )}
          {idx < items.length - 1 && <span className="px-1">&gt;</span>}
        </span>
      ))}
    </nav>
  );
};

export default Breadcrumbs;
